import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  console.log(url);
  name = name.replace(/[\\[\\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

let formData;
  var request = new XMLHttpRequest();
  request.onreadystatechange = (e) => {
    if (request.readyState !== 4) {
      return;
    }
  
    if (request.status === 200) {
      let envelopeData = JSON.parse( request.responseText);  
      formData = envelopeData; 
 
      ReactDOM.render(<App formData={formData}/>, document.getElementById('root'));
      registerServiceWorker();
      

    } else {
      console.warn('error');
    }
  };

  let basePath = 'https://odernichtoderdoch.de/addons/rezepte/';
  let baseUrl = 'envelope/json';
  let cryptKey = getParameterByName('cryptKey');
  //console.log(cryptKey);
  if(cryptKey != null) {
    baseUrl = 'edit/' + cryptKey + '/json';
  }
  request.open('GET', basePath + baseUrl);
  request.send();



  console.error = (function() {
    var error = console.error

    return function(exception) {
        if ((exception + '').indexOf('Warning: A component is `contentEditable`') !== 0) {
            error.apply(console, arguments)
        }
    }
})()


// WEBPACK FOOTER //
// ./src/index.js